import {ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatFormFieldModule} from '@angular/material/form-field';
import {FormArray, FormBuilder, FormControl, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {MatIcon} from '@angular/material/icon';
import {MatButton, MatIconButton} from '@angular/material/button';
import {MatExpansionPanel, MatExpansionPanelHeader} from '@angular/material/expansion';
import {
    GroupService,
    IndicatorService,
    ObjectTypeDto,
    OrganizationService,
    ReferenceListDto,
    ReferenceService,
} from '../../../apiModule1';
import {MultiSelect3Component} from '../../../../shared/components/multi-select3/multi-select3.component';
import {map} from 'rxjs/operators';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';


@Component({
    selector: 'pas-dialog-organization',
    standalone: true,
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.scss', '../../index-entity/dialog/dialog.component.scss', '../../index-entity/filling-method/filling-method.component.scss'],
    imports: [
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        ReactiveFormsModule,
        MatIcon,
        MatIconButton,
        MatButton,
        MatExpansionPanel,
        MatExpansionPanelHeader,
        MultiSelect3Component,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DialogComponent implements OnInit {

    isNew: boolean = false;

    cbTypes: (IdName)[] = []

    options: Record<string, { object: ObjectTypeDto[], pageSize: number }> = {
        group: {object: ['OrganizationGroup'], pageSize: 1e6},
        object: {object: ['ObjectGroup'], pageSize: 1e6},
        excludedIndicators: {object: ['ObjectGroup'], pageSize: 1e6},
    }

    form = this.fb.group({
        name: ['', [Validators.required]],
        iasid: this.fb.control<number | string>('', [Validators.required]),
        group: this.fb.control<Group[]>([], [Validators.required]),
        object: this.fb.control<Group[]>([], [Validators.required]),
        excludedIndicators: this.fb.control<Indicator[]>([]),
        cb: this.fb.array<(boolean | null)[]>([]),
        email: ['', [Validators.required]]
    })
    isEnabled: boolean = false;

    get cbs() {
        return this.form.get('cb') as FormArray;
    }

    constructor(
        public dialogRef: MatDialogRef<DialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: Record<string, any>,
        public dataService: OrganizationService,
        public groupService: GroupService,
        public indicatorService: IndicatorService,
        private fb: FormBuilder,
        private referenceService: ReferenceService,
        private destroyRef: DestroyRef,
        private cdr: ChangeDetectorRef,
    )
    {
        this.isNew = data['isNew'];
        console.log('isNew', this.isNew, this.data);
    }

    _convertCBTypesToBoolean(cbTypes: ReferenceListDto[]): void {
        const controls = this.cbTypes
            .map((x: ReferenceListDto) => {
                const found = cbTypes.find(y => {
                    const res = y.code === x.code;
                    return res;
                })
                return new FormControl(!!found);
            });
        this.form.setControl('cb', new FormArray(controls));
        this.cdr.markForCheck();
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    onApply() {
        const res: Organization = {
            id: this.data['id'],
            name: this.form.get('name')!.value || '',
            iasId: this.form.get('iasid')!.value || this.data['iasid'],
            objectGroups: this.form.get('object')!.value || [],
            organizationGroups: this.form.get('group')!.value || [],
            cbTypes: this.cbTypes.filter((e: ReferenceListDto, i: number) => this.form.get('cb')!.value[i]),
            status: this.data['status'],
            excludedIndicators: this.form.get('excludedIndicators')!.value || [],
            email: this.form.get('email')!.value || '',
        }
        this.dialogRef.close(res);
    }

    ngOnInit() {
        this.form.get('iasid')!.valueChanges.subscribe(v => {
            if (!v || v === '-1') this.form.get('iasid')!.setValue('', {emitEvent: false});
            this.form.get('iasid')!.setValue((v + '').replace(/[^0-9]/g, ''), {emitEvent: false});
        })

        this.referenceService.apiReferenceCbtypesGet()
            .pipe(map(x => x.values))
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(v => {
                this.cbTypes = v || []

                const controls = this.cbTypes.map(_ => new FormControl(false));
                this.form.setControl('cb', new FormArray(controls));


                if (!this.isNew) {
                    (this.dataService as any)['apiOrganizationIdGet']({id: this.data['id']}).subscribe((i: Organization) => {
                        console.log('i', i);
                        if (!i) return;
                        i.name && this.form.get('name')!.setValue(i.name);
                        const iasId = !i.iasId || i.iasId === -1 ? '' : i.iasId;
                        i.iasId && this.form.get('iasid')!.setValue(iasId);
                        i.objectGroups && this.form.get('object')!.setValue(i.objectGroups);
                        i.organizationGroups && this.form.get('group')!.setValue(i.organizationGroups);
                        i.cbTypes && this._convertCBTypesToBoolean(i.cbTypes);
                        i.excludedIndicators && this.form.get('excludedIndicators')!.setValue(i.excludedIndicators);
                        i.email && this.form.get('email')!.setValue(i.email)
                    })
                }

                this.cdr.markForCheck();

            })

    }

    hasCbType(i: number): boolean {
        console.log('this.form.get(\'cb\')!.value', this.form.get('cb')!.value);
        return !!this.form.get('cb')!.value[i];
    }
}

